import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
/**
 * these classes are used to overrite some methods in the TLF classes,
 * because the abc-classes make problems i could not fix otherwise
 */
// flashx/textlayout/property/Property
var Property = /** @class */ (function (_super) {
    __extends(Property, _super);
    function Property() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Property.createObjectWithPrototype = function (obj) {
        var newObj = obj.sec.AXObject.axConstruct([]);
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                newObj[attr] = obj[attr];
            }
        }
        return newObj;
    };
    Property.forceNativeConstructor = false;
    Property.forceNativeMethods = true;
    return Property;
}(ASObject));
export { Property };
//flashx.textLayout.conversion.BaseTextLayoutImporter
var BaseTextLayoutImporter = /** @class */ (function (_super) {
    __extends(BaseTextLayoutImporter, _super);
    function BaseTextLayoutImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseTextLayoutImporter.prototype.checkNamespace = function (param1) {
        var _loc2 = param1.$Bgnamespace();
        //console.log('namespace of xml', _loc2.prefix, _loc2.uri, param1);
        //console.log('namespace of this', (<any> this).$Bgns.prefix, (<any> this).$Bgns.uri);
        if (!this._textFlowNamespace) {
            if (_loc2.uri != this.$Bgns.uri) {
                return false;
            }
            this._textFlowNamespace = _loc2;
        }
        else if (_loc2.uri != this._textFlowNamespace.uri) {
            return false;
        }
        //console.log('_textFlowNamespace', (<any> this)._textFlowNamespace.uri);
        return true;
    };
    BaseTextLayoutImporter.forceNativeConstructor = false;
    BaseTextLayoutImporter.forceNativeMethods = true;
    return BaseTextLayoutImporter;
}(ASObject));
export { BaseTextLayoutImporter };
var TLFTextField = /** @class */ (function (_super) {
    __extends(TLFTextField, _super);
    function TLFTextField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TLFTextField.prototype, "text", {
        set: function (param1) {
            console.log('set text native', param1);
        },
        enumerable: false,
        configurable: true
    });
    TLFTextField.forceNativeConstructor = false;
    TLFTextField.forceNativeMethods = true;
    return TLFTextField;
}(ASObject));
export { TLFTextField };
